//TODO: GET RID OF THIS WHEN PAYMENTS 2 ROLLS OUT

export function convertDollarToCents(dollarAmount: number): number {
  return Number.isInteger(dollarAmount * 100)
    ? dollarAmount * 100
    : parseInt((dollarAmount * 100).toFixed(0))
}

export async function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function tryParseInt(value: string, radix?: number, defaultReturn?: string): number | null {
  const parsed = parseInt(value, radix)
  if (isNaN(parsed)) {
    switch (defaultReturn) {
    case '0': return 0
    case 'null': return null
    case 'NaN': return NaN
    default: return null
    }
  }
  return parsed
}
